import { NgStyle } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type AvatarCardConfig } from './avatar-card.types';

@Component({
  selector: 'app-avatar-card',
  templateUrl: './avatar-card.html',
  imports: [Dynamic, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarCard {
  readonly config = input.required<AvatarCardConfig>();

  private readonly gradientStyle = signal<Record<string, string>>({});

  protected readonly backgroundStyle = computed(() => {
    if (this.config().showBackgroundGradient === false) {
      return { background: 'var(--avatarcard-background)' };
    }
    return this.gradientStyle();
  });

  constructor() {
    afterNextRender(() => {
      const gradient = getComputedStyle(document.documentElement)
        .getPropertyValue('--avatarcard-background-gradient')
        .trim();

      this.gradientStyle.set({
        background: `linear-gradient(180deg, var(--gradients-${gradient}-start), var(--gradients-${gradient}-middle), var(--gradients-${gradient}-stop))`,
      });
    });
  }
}
